import { render, staticRenderFns } from "./CustomErrorRegistration.vue?vue&type=template&id=61f25b78&scoped=true&lang=pug"
import script from "./CustomErrorRegistration.vue?vue&type=script&lang=js"
export * from "./CustomErrorRegistration.vue?vue&type=script&lang=js"
import style0 from "./CustomErrorRegistration.vue?vue&type=style&index=0&id=61f25b78&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61f25b78",
  null
  
)

export default component.exports